import { SerializedStyles } from '@emotion/react';
import { FC } from 'react';

import * as styles from './styles';

interface DotProps {
  color: string;
  customStyle?: SerializedStyles;
}

const Dot: FC<DotProps> = ({ color, customStyle }) => {
  return (
    <div css={[styles.container, customStyle]}>
      <svg
        width="8"
        height="8"
        viewBox="0 0 5 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="2.5" cy="3" r="2.5" fill={color} />
      </svg>
    </div>
  );
};

export default Dot;
